export const environment = {
  production: true,
  envName: "DemoCR HANA",
  apiUrl: "https://eracldemoapi.clavisco.com/"
};
